import { create } from 'zustand';
import http from 'helpers/requests';
import { findAssignSections } from 'modules/Common/utils/assignImports.api';

/**
 * The "Assign installation to imports" step for flows that create factors without a
 * dialog of their own to host it — the classic spreadsheet import and the Upload Hub
 * (backend docs/features/import-installation-backfill, D14). A flow hands over the
 * factors it created; `AssignImportsOfferHost` (mounted once in the app layout) shows
 * the step when any of them covers supplier-only imports.
 */
export const useAssignImportsOfferStore = create((set) => ({
  sections: null,
  setSections: (sections) => set({ sections }),
  close: () => set({ sections: null }),
}));

/** Offer the step for `factors` (created documents). Never throws: the factors are saved. */
export async function offerImportAssignment(factors) {
  if (!factors?.length) return;
  const sections = await findAssignSections(http, factors);
  if (sections.length > 0) useAssignImportsOfferStore.getState().setSections(sections);
}
